import clsx from 'clsx'
import React from 'react'
import {Consumer} from '../../context'
import Box from '@mui/material/Box'
import './premium-required.styl'

export default function PremiumRequired() {
  return (<Consumer>{ (context) => {
    const {translate} = context
    return (<Box>{translate('premium-required-message')}</Box>)
  }}</Consumer>)
}
